/**
 * Filtros globais compartilhados entre TODOS os componentes do dashboard.
 *
 * Convenção:
 * - `companyIds`: vazio/undefined = "todas as empresas" (super_admin); 1+ filtra
 * - `courseId`: undefined = "todos os cursos"
 * - `dateRange`: pre-set "30d" / "90d" / "all" OU range customizado
 */
export interface DashboardFilters {
  companyIds?: string[]
  courseId?: number
  dateFrom?: Date
  dateTo?: Date
}

/** Paleta consistente pros Recharts (compatível com o tema dark + laranja FCamara). */
export const CHART_COLORS = {
  primary: '#F26522', // laranja FCamara
  amber: '#FFB627', // dourado complementar
  sky: '#38BDF8', // azul céu
  fuchsia: '#D946EF', // rosa/magenta
  emerald: '#34D399', // verde
  muted: '#71717A', // cinza neutro
} as const

/** Helper pra montar dateFrom/To do filtro pros params da query. */
export function toDateParams(filters: DashboardFilters): {
  dateFrom?: string
  dateTo?: string
} {
  return {
    dateFrom: filters.dateFrom?.toISOString(),
    dateTo: filters.dateTo?.toISOString(),
  }
}
